import Utils from "./Utils";

class UserSettings {
  static getTabSubscriptionVisibility() {
    return Utils.getApaMetadataKey('tab_subscription_visibility', '{"enable":false}');
  }
}
export default UserSettings;



// WEBPACK FOOTER //
// ./src/utils/UserSettings.js